import { useState } from 'react';

export const useTraceCompare = () => {
  const [selectingCompare, setSelectingCompare] = useState(false);
  const [compareRunId, setCompareRunId] = useState<string | null>(null);
  const [isShowingDiff, setIsShowingDiff] = useState(false);
  const [isAutoTracking, setIsAutoTracking] = useState(true);
  const [isScrollingSynced, setIsScrollingSynced] = useState(true);
  const handleSelectCompare = (runId: string | null) => {
    setSelectingCompare(false);
    setCompareRunId(runId);
  };

  const resetCompareState = () => {
    setIsShowingDiff(false);
    setIsAutoTracking(true);
    setIsScrollingSynced(true);
  };

  return {
    selectingCompare,
    compareRunId,
    handleSelectCompare,
    setSelectingCompare,
    isShowingDiff,
    setIsShowingDiff,
    isAutoTracking,
    setIsAutoTracking,
    isScrollingSynced,
    setIsScrollingSynced,
    resetCompareState,
  };
};
